//
// AutoInteractionController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModelController";
import "./ExpressionControlItem";
import "../../../models/view/AutoInteractionMode";

var AutoInteractionController = createModule("BIRD::AutoInteractionController", ["BIRD::BIRDModelController"], EventDispatcher, [
    {
        EXPRESSION_UPDATED: 50000,
    },
    ,
    ,
    ,
    {
        getExpressionControlItems: [[1]],
        getAutoInteractionMode: [4],
    },
    ,
    ,
]);
export default AutoInteractionController;
